// Hides password fields — auth uses OAuth (Microsoft, Google Workspace) or email code only.
const elements = {
  formFieldRow__password: { display: "none" },
  formFieldRow__confirmPassword: { display: "none" },
  formFieldRow__currentPassword: { display: "none" },
  formFieldRow__newPassword: { display: "none" },
  formField__password: { display: "none" },
  formField__confirmPassword: { display: "none" },
  formField__currentPassword: { display: "none" },
  formField__newPassword: { display: "none" },
  formFieldInput__password: { display: "none" },
  formFieldInput__confirmPassword: { display: "none" },
  formFieldInput__currentPassword: { display: "none" },
  formFieldInput__newPassword: { display: "none" },
  formFieldLabelRow__password: { display: "none" },
  formFieldLabelRow__confirmPassword: { display: "none" },
  formFieldLabelRow__currentPassword: { display: "none" },
  formFieldLabelRow__newPassword: { display: "none" },
  formFieldLabel__password: { display: "none" },
  formFieldLabel__confirmPassword: { display: "none" },
  formFieldLabel__currentPassword: { display: "none" },
  formFieldLabel__newPassword: { display: "none" },
  formFieldHintText__password: { display: "none" },
  formFieldHintText__confirmPassword: { display: "none" },
  formFieldHintText__currentPassword: { display: "none" },
  formFieldHintText__newPassword: { display: "none" },
  formFieldErrorText__password: { display: "none" },
  formFieldErrorText__confirmPassword: { display: "none" },
  formFieldErrorText__currentPassword: { display: "none" },
  formFieldErrorText__newPassword: { display: "none" },
  formFieldInputShowPasswordButton: { display: "none" },
  formFieldInputShowPasswordIcon: { display: "none" },
} as const;

export const clerkAppearance = { elements };

// Dark-theme palette mirroring the app's design tokens (see index.css [data-theme="dark"]).
// Clerk renders its components on its own card surface — without these the card stays
// white in dark mode and the inputs/OTP code boxes become unreadable. Driving Clerk's
// official `variables` API darkens the whole card (header, inputs, footer, dev banner)
// consistently and survives Clerk version bumps, unlike per-class CSS overrides.
const darkVariables = {
  colorBackground: "#171717", // --card
  colorText: "#fafafa", // --foreground
  colorTextSecondary: "#a1a1a1", // --muted-foreground
  colorInputBackground: "#262626", // --secondary
  colorInputText: "#fafafa",
  colorNeutral: "#fafafa", // base Clerk derives borders/dividers/shadows from
};

export function getClerkAppearance(theme: "light" | "dark") {
  if (theme === "dark") {
    return {
      variables: darkVariables,
      elements: {
        ...elements,
        // Clerk renders these secondary links quite dim on the dark card —
        // lighten them so "Resend" and "Use another method" stay legible.
        formResendCodeLink: { color: "#d4d4d4" },
        footerActionLink: { color: "#d4d4d4" },
      },
    };
  }
  return { elements };
}
